<template>
  <div class="header mt-3 mt-md-0">
    <div class="header-body">
      <div class="row align-items-end">
        <div class="col">
          <h6 class="header-pretitle">
            {{ preTitle }}
          </h6>
          <h1 class="header-title">
            {{ title }}
          </h1>
        </div>
        <div class="col-auto">
          <ul class="nav nav-tabs header-tabs">
            <li
              v-for="menu in tabMenu"
              class="nav-item"
            >
              <div
                class="nav-link text-center"
                :class="activeNavClass(menu.value)"
                @click="handleClickNavItem(menu.value)"
              >
                {{ menu.title }}
                <span
                  v-if="hasAmount"
                  class="badge badge-soft-dark"
                >
                  {{ menu.amount }}
                </span>
              </div>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'PageHeaderWithTab',
  props: {
    title: {
      type: String,
    },
    preTitle: {
      type: String,
    },
    tabMenu: {
      type: Array,
      validator(menus) {
        return menus.filter(menu => menu.hasOwnProperty('value')).length > 0;
      },
    },
    hasAmount: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      curMenu: this.tabMenu.length > 0 ? this.tabMenu[0].value : null,
    };
  },
  watch: {
    curMenu: {
      immediate: true,
      handler(value) {
        const curTabMenu = this.tabMenu.find(menu => menu.value === value);
        this.$emit('change', curTabMenu);
      },
    },
  },
  methods: {
    activeNavClass(itemValue) {
      return this.curMenu === itemValue ? 'active' : '';
    },
    handleClickNavItem(title) {
      this.curMenu = title;
    },
  },
};
</script>
